import * as React from 'react'

import { cn } from '../../lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-bg-hover animate-pulse rounded-sm', className)}
      {...props}
    />
  )
}

export { Skeleton }
